import React from 'react';
import {connect} from "react-redux";
import {withRouter, NavLink} from 'react-router-dom'
import RsvpButton from './RsvpButton/RsvpButton'

import './header-navbar.scss';
import TextTranslate from '../../TextTranslate/TextTranslate';

const HeaderNavbar = ({isMobile, ...props}) => {

    return (
        <div className="container-navbar">
            <div className="container">
                <div className="row no-gutters overflow-hidden">
                    <div className="navbar-container col-12 d-flex justify-content-between">
                        <ul>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/invitation">
                                    <TextTranslate name="invitation-your-invitation" fallback="Your Invitation"/>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/experience">
                                    <TextTranslate name="experience-your-experience" fallback="Your Experience"/>
                                </NavLink>
                            </li>
                            {/* <li>
                                <NavLink
                                    activeClassName="active"
                                    to="/partnership">
                                    <TextTranslate name="partnership-neom-partnership" fallback="NEOM Partnership"/>
                                </NavLink>
                            </li> */}
                            {!isMobile && <>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        to="/faq">
                                        <TextTranslate name="word-faq" fallback="FAQ"/>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        activeClassName="active"
                                        to="/contact">
                                        <TextTranslate name="word-contact-us" fallback="Contact Us"/>
                                    </NavLink>
                                </li>
                            </>}
                        </ul>
                        <div className="rsvp-now">
                            <RsvpButton />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.general.isMobile,
    auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(HeaderNavbar));
